export default {
  "content": "<g clip-path=\"url(#clip0_3375_60158)\"><path d=\"M19.933.666h-12.8A2.133 2.133 0 005 2.799v21.334a2.133 2.133 0 002.133 2.133h12.8a2.133 2.133 0 002.134-2.133V2.799A2.133 2.133 0 0019.933.666zm-6.4 3.2a3.734 3.734 0 110 7.467 3.734 3.734 0 010-7.467zm3.2 18.133h-6.4a1.066 1.066 0 110-2.133h6.4a1.067 1.067 0 010 2.133zm1.067-4.266H9.267a1.067 1.067 0 010-2.134H17.8a1.066 1.066 0 110 2.134z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_3375_60158\"><path fill=\"#fff\" transform=\"translate(.733 .666)\" d=\"M0 0h25.6v25.6H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "27",
    "height": "27",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};